import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\FetchInvoiceDossierForSelectByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchInvoiceDossierForSelectByIdController.php
* @route '/api/dossier-invoices-for-select/{dossier}'
*/
const FetchInvoiceDossierForSelectByIdController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchInvoiceDossierForSelectByIdController.url(args, options),
    method: 'get',
})

FetchInvoiceDossierForSelectByIdController.definition = {
    methods: ["get","head"],
    url: '/api/dossier-invoices-for-select/{dossier}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\FetchInvoiceDossierForSelectByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchInvoiceDossierForSelectByIdController.php
* @route '/api/dossier-invoices-for-select/{dossier}'
*/
FetchInvoiceDossierForSelectByIdController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchInvoiceDossierForSelectByIdController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\FetchInvoiceDossierForSelectByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchInvoiceDossierForSelectByIdController.php
* @route '/api/dossier-invoices-for-select/{dossier}'
*/
FetchInvoiceDossierForSelectByIdController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchInvoiceDossierForSelectByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\FetchInvoiceDossierForSelectByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchInvoiceDossierForSelectByIdController.php
* @route '/api/dossier-invoices-for-select/{dossier}'
*/
FetchInvoiceDossierForSelectByIdController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchInvoiceDossierForSelectByIdController.url(args, options),
    method: 'head',
})

export default FetchInvoiceDossierForSelectByIdController